<div class="ortho-compact-pair-photo-container gap-50-grid">
  <div>
    @if (showHeaders) {
    <div class="fs-16 m-b-25 heading">
      {{ 'ortho.assessment' | translate }}
    </div>
    } @for (preSurgeryImageUrl of preTreatmentImagesUrl; track preSurgeryImageUrl; let i = $index) {
    <div class="flex-column-container">
      <stx-image-thumbnail
        [mediaAnonymized]="prePhotoAnonymized"
        [thumbnailId]="'pre-pair-' + preTreatmentIds[i]"
        imageAlt="{{ label }}"
        [imageUrl]="preSurgeryImageUrl"
        [mediaId]="preTreatmentIds[i]"
      >
        {{ fullImageLabel }}
      </stx-image-thumbnail>
    </div>
    }
  </div>
  @if (postTreatmentImagesUrl.length) {
  <div>
    @if (showHeaders) {
    <div class="fs-16 m-b-25 heading">
      {{ 'ortho.treatment' | translate }}
    </div>
    } @for (postSurgeryImageUrl of postTreatmentImagesUrl; track postSurgeryImageUrl; let i = $index) {
    <div class="flex-column-container">
      <stx-image-thumbnail
        [thumbnailId]="'post-pair-' + preTreatmentIds[i]"
        imageAlt="{{ label }}"
        [imageUrl]="postSurgeryImageUrl"
        [mediaId]="postTreatmentIds[i]"
        [mediaAnonymized]="postPhotoAnonymized"
      >
        {{ fullImageLabel }}
      </stx-image-thumbnail>
    </div>
    }
  </div>
  }
</div>
